import * as React from '@wordpress/element';
import { createHigherOrderComponent } from '@wordpress/compose';
import {
	BlockControls,
	store as blockEditorStore,
} from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton, Dashicon } from '@wordpress/components';
import {
	useCurrentView,
	useEditEntryBlock,
	useEntriesBlock,
	useEntriesIndexBlock,
	useViewEntryBlock,
} from '../../hooks';
import { __ } from '@wordpress/i18n';
import { useDispatch } from '@wordpress/data';

const ViewSelectorToolbar = createHigherOrderComponent((BlockEdit) => {
	return (props: any) => {
		const currentView = useCurrentView();
		const entriesBlock = useEntriesBlock();
		const indexBlock = useEntriesIndexBlock();
		const viewEntryBlock = useViewEntryBlock();
		const editEntryBlock = useEditEntryBlock();
		const { selectBlock } = useDispatch(blockEditorStore);

		if (
			!currentView ||
			!entriesBlock ||
			entriesBlock.attributes.mode !== 'multi-entry'
		) {
			return <BlockEdit {...props} />;
		}

		const toolbarButtons = [
			<ToolbarButton
				key="view-button-entries"
				icon={<Dashicon icon="index-card" />}
				label={__('Switch to Entries View', 'gp-entry-blocks')}
				isActive={currentView === 'entries'}
				onClick={() =>
					selectBlock(indexBlock?.clientId ?? entriesBlock.clientId)
				}
			/>,
		];

		if (viewEntryBlock) {
			toolbarButtons.push(
				<ToolbarButton
					key="view-button-view"
					icon={<Dashicon icon="media-default" />}
					label={__('Switch to Single Entry View', 'gp-entry-blocks')}
					isActive={currentView === 'view'}
					onClick={() => selectBlock(viewEntryBlock.clientId)}
				/>
			);
		}

		if (editEntryBlock) {
			toolbarButtons.push(
				<ToolbarButton
					key="view-button-edit"
					icon={<Dashicon icon="welcome-write-blog" />}
					label={__('Switch to Edit Entry View', 'gp-entry-blocks')}
					isActive={currentView === 'edit'}
					onClick={() => selectBlock(editEntryBlock.clientId)}
				/>
			);
		}

		return (
			<React.Fragment>
				<BlockEdit {...props} />
				<BlockControls>
					<ToolbarGroup>{toolbarButtons}</ToolbarGroup>
				</BlockControls>
			</React.Fragment>
		);
	};
}, 'withInspectorControl');

export default ViewSelectorToolbar;
